<template>
    <!-- Employee Request Tab View From Manage Request Component -->
    <div class="">
        <h6 class="request-tab-header">
            Employees Requests
        </h6>
        <div v-if="showIllustrator">
            <div class="row" style="height: 308px;">
                <div class="col-lg-12 text-center py-3 px-3 mt-10">
                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/no_employees_white.svg" class="img-fluid" style="width: 150px;">
                    <h5 class="pt-3 pb-5" style="color: #fff;">No Employee Requests</h5>
                </div>
            </div>
        </div>
        <div v-if="!showIllustrator">
            <div class="page-header-search text-auto row no-gutters align-items-center justify-content-between">
                <div class="col search-wrapper" style="padding-left: 63px;">
                    <div id="searchdigigrey">
                        <div id="newsearchgrey">
                            <input type="text" @input="getUserEmployeeRequest('searchKey')" v-model="searchKey" placeholder="Search Employees" />
                        </div>
                    </div>
                </div>
                <div class="col" v-if="total">
                    <div class="row no-gutters align-items-end pull-right">
                        <div class="pr-4">
                            <div class="pagination-footer">
                                <span class="page-info px-1 pt-2 fw-600" style="height: 2.4rem;line-height: 2.4rem;color: #fff;font-size: 14px;">
                                    {{start}} - {{end}} of {{total}}
                                </span>
                                <button type="button" class="btn btn-icon" id="previous" style="padding: 4px 1.8px 0.8rem 2px;" :disabled="count <=0" :class="{'disabled':ajaxCallinprogress}" @click="getUserEmployeeRequest('prev')">
                                    <el-tooltip class="item" effect="dark" content="Previous" placement="top">
                                        <i class="icon icon-chevron-left" style="color: #fff !important;"></i>
                                    </el-tooltip>
                                </button>
                                <button type="button" class="btn btn-icon" id="next" style="padding-left:1.8px;padding-top: 4px;" :disabled="end >= total"
                                    :class="{'disabled':ajaxCallinprogress}" @click="getUserEmployeeRequest('next')">
                                    <el-tooltip class="item" effect="dark" content="Next" placement="top">
                                        <i class="icon icon-chevron-right" style="color: #fff !important;"></i>
                                    </el-tooltip>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-if="ajaxCallinprogress">
                <div class="col-lg-12 py-5 px-3 mt-10">
                    <div class="flex-container">
                        <half-circle-spinner :animation-duration="1000" :size="60" color="#fff" />
                    </div>
                </div>
            </div>
            <div class="row" v-if="!ajaxCallinprogress && employeeDataCount.length === 0" style="height: 308px;">
                <div v-if="searchKey" class="col-lg-12 text-center py-3 px-3 mt-10">
                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/no_employees_white.svg" class="img-fluid" style="width: 150px;">
                    <h5 class="pt-3 pb-5" style="color: #fff;">No Employee Found</h5>
                </div>
                <div v-else class="col-lg-12 text-center py-3 px-3 mt-10">
                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/no_employees_white.svg" class="img-fluid" style="width: 150px;">
                    <h5 class="pt-3 pb-5" style="color: #fff;">No Employee Requests</h5>
                </div>
            </div>
            <div class="request-section managerequests-uk-grid-width-small-1-2 managerequests-uk-grid-width-medium-1-3 managerequests-uk-grid-width-large-1-24 managerequests-uk-grid-width-xlarge-1-23" v-if="!ajaxCallinprogress">
                <div class="card-box" v-for="(employeeConnectionsList, index) in employeeDataCount" :key="index">
                    <div class="md-card request-card md-card-hover" >
                        <div class="md-card-head">
                            <div class="text-center">
                                <div class="img-div">
                                    <img class="md-card-head-avatar" :src="employeeConnectionsList.company.logo||'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" :alt="employeeConnectionsList.invited_by.full_name">
                                </div>
                            </div>
                            <h3 class="md-card-head-text text-center">
                                <span :title="employeeConnectionsList.company.company_name">{{employeeConnectionsList.company.company_name}}</span>
                                <span class="managerequests-uk-text-truncate des-box-manage" :title="employeeConnectionsList.company.primary_email.value">{{employeeConnectionsList.company.primary_email.value}}</span>
                            </h3>
                        </div>
                        <div class="md-card-content text-center">
                            <a class="btn btn-secondary btn-smm mx-1 mb-3" v-on:click.once="changeEmployeeStatus('active',employeeConnectionsList._id)">Accept</a>
                            <a class="btn btn-danger btn-smm mx-1 mb-3" v-on:click.once="changeEmployeeStatus('declined',employeeConnectionsList._id)">Reject</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

// import navbarMixin from "./mixins/navbarMixin.js";
import { HalfCircleSpinner } from 'epic-spinners'
export default {
  data() {
    return {
        employeeDataCount: [],
        ajaxCallinprogress: false,
        searchKey: "",
        total:0,
        skip: 0,
        limit: 10,
        start: 1,
        end: 0,
        count: 0,
        showIllustrator:false
    };
  },
  components: {
    HalfCircleSpinner
  },
//   mixins:[navbarMixin],
  methods: {
      // Checking Employee Requests
    getUserEmployeeRequest(param){
        if (param == 'prev') this.count--;
        else if (param == 'next') this.count++;
        else if (param == 'init') {
            this.count = 0;
        } else if (param == 'searchKey') {
            this.count = 0;
        }
        this.ajaxCallinprogress = true;
        this.employeeDataCount = []
        this.$http
        .post("/employees/user_pending_requests", {
                skip: this.count * this.limit,
                limit: this.limit,
                search_key: this.searchKey
        })
        .then(res => {
            if (res.data.status_id == 1) {
                this.employeeDataCount = res.data.response;
                this.total = res.data.total
                this.start = this.count * this.limit + 1;
                this.end = this.count * this.limit + this.limit < this.total ?
                    this.count * this.limit + this.limit :
                    this.total;
                this.ajaxCallinprogress = false;
                if (this.employeeDataCount.length == 0 && !this.ajaxCallinprogress && !this.searchKey) {
                    this.showIllustrator = true
                } else {
                    this.showIllustrator = false
                }
            }
        });
    },

    // Accept or Reject Request Status
    changeEmployeeStatus(status, id) {
      this.$http
        .post("/employees/change_employee_status", {
          status: status,
          employee_id: id,
        })
        .then(result => {
          this.checkPageCount();
        });
    },
    checkPageCount() {
        if (this.count >= 1) {
            if (this.total <= this.count * this.limit + 1) {
                this.count--;
            }
        }
        this.getUserEmployeeRequest()
    }
  },
  computed:{
    account(){
	  return this.$store.state.account;
	},
  },
//   created(){
//       this.getRequestType();
//       this.getUserEmployeeRequest();
//   }
  mounted(){
      this.getUserEmployeeRequest('init');
  }
};
</script>
<style>
.managerequests-uk-grid{
    display:-ms-flexbox;
    display:-webkit-flex;
    display:flex;
    -ms-flex-wrap:wrap;
    -webkit-flex-wrap:wrap;
    flex-wrap:wrap;
    margin:0;
    padding:0;
    list-style:none
}
.managerequests-uk-grid:after,.managerequests-uk-grid:before{
    content:"";
    display:block;
    overflow:hidden
}
.managerequests-uk-grid:after{
    clear:both
}
.managerequests-uk-grid>*{
    -ms-flex:none;
    -webkit-flex:none;
    flex:none;
    margin:0;
    float:left
}
.managerequests-uk-grid>*>:last-child{
    margin-bottom:0
}
.managerequests-uk-grid{
    margin-left:-25px
}
.managerequests-uk-grid>*{
    padding-left:25px
}
.managerequests-uk-grid+.managerequests-uk-grid,.managerequests-uk-grid-margin,.managerequests-uk-grid>*>.managerequests-uk-panel+.managerequests-uk-panel{
    margin-top:25px
}
@media (min-width:1220px){
    .managerequests-uk-grid{
        margin-left:-35px
    }
    .managerequests-uk-grid>*{
        padding-left:35px
    }
    .managerequests-uk-grid+.managerequests-uk-grid,.managerequests-uk-grid-margin,.managerequests-uk-grid>*>.managerequests-uk-panel+.managerequests-uk-panel{
        margin-top:35px
    }
}
.managerequests-uk-grid-collapse{
    margin-left:0
}
.managerequests-uk-grid-collapse>*{
    padding-left:0
}
.managerequests-uk-grid-collapse+.managerequests-uk-grid-collapse,.managerequests-uk-grid-collapse>*>.managerequests-uk-panel+.managerequests-uk-panel,.managerequests-uk-grid-collapse>.managerequests-uk-grid-margin{
    margin-top:0
}
.managerequests-uk-grid-small{
    margin-left:-10px
}
.managerequests-uk-grid-small>*{
    padding-left:10px
}
.managerequests-uk-grid-small+.managerequests-uk-grid-small,.managerequests-uk-grid-small>*>.managerequests-uk-panel+.managerequests-uk-panel,.managerequests-uk-grid-small>.managerequests-uk-grid-margin{
    margin-top:10px
}
.managerequests-uk-grid-medium{
    margin-left:-25px
}
.managerequests-uk-grid-medium>*{
    padding-left:25px
}
.managerequests-uk-grid-medium+.managerequests-uk-grid-medium,.managerequests-uk-grid-medium>*>.managerequests-uk-panel+.managerequests-uk-panel,.managerequests-uk-grid-medium>.managerequests-uk-grid-margin{
    margin-top:25px
}
@media (min-width:960px){
    .managerequests-uk-grid-large{
        margin-left:-35px
    }
    .managerequests-uk-grid-large>*{
        padding-left:35px
    }
    .managerequests-uk-grid-large+.managerequests-uk-grid-large,.managerequests-uk-grid-large-margin,.managerequests-uk-grid-large>*>.managerequests-uk-panel+.managerequests-uk-panel{
        margin-top:35px
    }
}
@media (min-width:1220px){
    .managerequests-uk-grid-large{
        margin-left:-50px
    }
    .managerequests-uk-grid-large>*{
        padding-left:50px
    }
    .managerequests-uk-grid-large+.managerequests-uk-grid-large,.managerequests-uk-grid-large-margin,.managerequests-uk-grid-large>*>.managerequests-uk-panel+.managerequests-uk-panel{
        margin-top:50px
    }
}
.managerequests-uk-grid-divider:not(:empty){
    margin-left:-25px;
    margin-right:-25px
}
.managerequests-uk-grid-divider>*{
    padding-left:25px;
    padding-right:25px
}
.managerequests-uk-grid-divider>[class*=managerequests-uk-width-9-]:nth-child(n+2),.managerequests-uk-grid-divider>[class*=managerequests-uk-width-1-]:not(.managerequests-uk-width-1-1):nth-child(n+2),.managerequests-uk-grid-divider>[class*=managerequests-uk-width-2-]:nth-child(n+2),.managerequests-uk-grid-divider>[class*=managerequests-uk-width-3-]:nth-child(n+2),.managerequests-uk-grid-divider>[class*=managerequests-uk-width-4-]:nth-child(n+2),.managerequests-uk-grid-divider>[class*=managerequests-uk-width-5-]:nth-child(n+2),.managerequests-uk-grid-divider>[class*=managerequests-uk-width-6-]:nth-child(n+2),.managerequests-uk-grid-divider>[class*=managerequests-uk-width-7-]:nth-child(n+2),.managerequests-uk-grid-divider>[class*=managerequests-uk-width-8-]:nth-child(n+2){
    border-left:1px solid #ddd
}
@media (min-width:768px){
    .managerequests-uk-grid-divider>[class*=managerequests-uk-width-medium-]:not(.managerequests-uk-width-medium-1-1):nth-child(n+2){
        border-left:1px solid #ddd
    }
}
@media (min-width:960px){
    .managerequests-uk-grid-divider>[class*=managerequests-uk-width-large-]:not(.managerequests-uk-width-large-1-1):nth-child(n+2){
        border-left:1px solid #ddd
    }
}
@media (min-width:1220px){
    .managerequests-uk-grid-divider:not(:empty){
        margin-left:-35px;
        margin-right:-35px
    }
    .managerequests-uk-grid-divider>*{
        padding-left:35px;
        padding-right:35px
    }
    .managerequests-uk-grid-divider:empty{
        margin-top:35px;
        margin-bottom:35px
    }
}
.managerequests-uk-grid-divider:empty{
    margin-top:25px;
    margin-bottom:25px;
    border-top:1px solid #ddd
}
.managerequests-uk-grid-match>*{
    display:-ms-flexbox;
    display:-webkit-flex;
    display:flex;
    -ms-flex-wrap:wrap;
    -webkit-flex-wrap:wrap;
    flex-wrap:wrap
}
.managerequests-uk-grid-match>*>*{
    -ms-flex:none;
    -webkit-flex:none;
    flex:none;
    box-sizing:border-box;
    width:100%
}
/* [class*=managerequests-uk-grid-width]>*{
    box-sizing:border-box;
    width:100%
} */
.managerequests-uk-grid-width-1-2>*{
    width:50%
}
.managerequests-uk-grid-width-1-3>*{
    width:33.333%
}
.managerequests-uk-grid-width-1-4>*{
    width:25%
}
.managerequests-uk-grid-width-1-5>*{
    width:20%
}
.managerequests-uk-grid-width-1-6>*{
    width:16.666%
}
.managerequests-uk-grid-width-1-10>*{
    width:10%
}
.managerequests-uk-grid-width-auto>*{
    width:auto
}
@media (min-width:480px){
    .managerequests-uk-grid-width-small-1-1>*{
        width:100%
    }
    .managerequests-uk-grid-width-small-1-2>*{
        width:50%
    }
    .managerequests-uk-grid-width-small-1-3>*{
        width:33.333%
    }
    .managerequests-uk-grid-width-small-1-4>*{
        width:25%
    }
    .managerequests-uk-grid-width-small-1-5>*{
        width:20%
    }
    .managerequests-uk-grid-width-small-1-6>*{
        width:16.666%
    }
    .managerequests-uk-grid-width-small-1-10>*{
        width:10%
    }
}
@media (min-width:768px){
    .managerequests-uk-grid-width-medium-1-1>*{
        width:100%
    }
    .managerequests-uk-grid-width-medium-1-2>*{
        width:50%
    }
    .managerequests-uk-grid-width-medium-1-3>*{
        width:33.333%
    }
    .managerequests-uk-grid-width-medium-1-4>*{
        width:25%
    }
    .managerequests-uk-grid-width-medium-1-5>*{
        width:20%
    }
    .managerequests-uk-grid-width-medium-1-6>*{
        width:16.666%
    }
    .managerequests-uk-grid-width-medium-1-10>*{
        width:10%
    }
}
@media (min-width:960px){
    .managerequests-uk-grid-width-large-1-1>*{
        width:100%
    }
    .managerequests-uk-grid-width-large-1-2>*{
        width:50%
    }
    .managerequests-uk-grid-width-large-1-3>*{
        width:33.333%
    }
    .managerequests-uk-grid-width-large-1-4>*{
        width:25%
    }
    .managerequests-uk-grid-width-large-1-24>*{
        width:24%
    }
    .managerequests-uk-grid-width-large-1-5>*{
        width:20%
    }
    .managerequests-uk-grid-width-large-1-6>*{
        width:16.666%
    }
    .managerequests-uk-grid-width-large-1-10>*{
        width:10%
    }
}
@media (min-width:1220px){
    .managerequests-uk-grid-width-xlarge-1-1>*{
        width:100%
    }
    .managerequests-uk-grid-width-xlarge-1-2>*{
        width:50%
    }
    .managerequests-uk-grid-width-xlarge-1-3>*{
        width:33.333%
    }
    .managerequests-uk-grid-width-xlarge-1-4>*{
        width:25%
    }
    .managerequests-uk-grid-width-xlarge-1-5>*{
        width:20%
    }
    .managerequests-uk-grid-width-xlarge-1-23>* {
        width: 23%!important;
    }
    .managerequests-uk-grid-width-xlarge-1-6>*{
        width:16.666%
    }
    .managerequests-uk-grid-width-xlarge-1-16>*{
        width:16% !important;
    }
    .managerequests-uk-grid-width-xlarge-1-10>*{
        width:10%
    }
}
[class*=managerequests-uk-width]{
    box-sizing:border-box;
    width:100%
}
.managerequests-uk-width-1-1{
    width:100%
}
.managerequests-uk-width-1-2,.managerequests-uk-width-2-4,.managerequests-uk-width-3-6,.managerequests-uk-width-5-10{
    width:50%
}
.managerequests-uk-width-1-3,.managerequests-uk-width-2-6{
    width:33.333%
}
.managerequests-uk-width-2-3,.managerequests-uk-width-4-6{
    width:66.666%
}
.managerequests-uk-width-1-4{
    width:25%
}
.managerequests-uk-width-3-4{
    width:75%
}
.managerequests-uk-width-1-5,.managerequests-uk-width-2-10{
    width:20%
}
.managerequests-uk-width-2-5,.managerequests-uk-width-4-10{
    width:40%
}
.managerequests-uk-width-3-5,.managerequests-uk-width-6-10{
    width:60%
}
.managerequests-uk-width-4-5,.managerequests-uk-width-8-10{
    width:80%
}
.managerequests-uk-width-1-6{
    width:16.666%
}
.managerequests-uk-width-5-6{
    width:83.333%
}
.managerequests-uk-width-1-10{
    width:10%
}
.managerequests-uk-width-3-10{
    width:30%
}
.managerequests-uk-width-7-10{
    width:70%
}
.managerequests-uk-width-9-10{
    width:90%
}
@media (min-width:480px){
    .managerequests-uk-width-small-1-1{
        width:100%
    }
    .managerequests-uk-width-small-1-2,.managerequests-uk-width-small-2-4,.managerequests-uk-width-small-3-6,.managerequests-uk-width-small-5-10{
        width:50%
    }
    .managerequests-uk-width-small-1-3,.managerequests-uk-width-small-2-6{
        width:33.333%
    }
    .managerequests-uk-width-small-2-3,.managerequests-uk-width-small-4-6{
        width:66.666%
    }
    .managerequests-uk-width-small-1-4{
        width:25%
    }
    .managerequests-uk-width-small-3-4{
        width:75%
    }
    .managerequests-uk-width-small-1-5,.managerequests-uk-width-small-2-10{
        width:20%
    }
    .managerequests-uk-width-small-2-5,.managerequests-uk-width-small-4-10{
        width:40%
    }
    .managerequests-uk-width-small-3-5,.managerequests-uk-width-small-6-10{
        width:60%
    }
    .managerequests-uk-width-small-4-5,.managerequests-uk-width-small-8-10{
        width:80%
    }
    .managerequests-uk-width-small-1-6{
        width:16.666%
    }
    .managerequests-uk-width-small-5-6{
        width:83.333%
    }
    .managerequests-uk-width-small-1-10{
        width:10%
    }
    .managerequests-uk-width-small-3-10{
        width:30%
    }
    .managerequests-uk-width-small-7-10{
        width:70%
    }
    .managerequests-uk-width-small-9-10{
        width:90%
    }
}
@media (min-width:768px){
    .managerequests-uk-width-medium-1-1{
        width:100%
    }
    .managerequests-uk-width-medium-1-2,.managerequests-uk-width-medium-2-4,.managerequests-uk-width-medium-3-6,.managerequests-uk-width-medium-5-10{
        width:50%
    }
    .managerequests-uk-width-medium-1-3,.managerequests-uk-width-medium-2-6{
        width:33.333%
    }
    .managerequests-uk-width-medium-2-3,.managerequests-uk-width-medium-4-6{
        width:66.666%
    }
    .managerequests-uk-width-medium-1-4{
        width:25%
    }
    .managerequests-uk-width-medium-3-4{
        width:75%
    }
    .managerequests-uk-width-medium-1-5,.managerequests-uk-width-medium-2-10{
        width:20%
    }
    .managerequests-uk-width-medium-2-5,.managerequests-uk-width-medium-4-10{
        width:40%
    }
    .managerequests-uk-width-medium-3-5,.managerequests-uk-width-medium-6-10{
        width:60%
    }
    .managerequests-uk-width-medium-4-5,.managerequests-uk-width-medium-8-10{
        width:80%
    }
    .managerequests-uk-width-medium-1-6{
        width:16.666%
    }
    .managerequests-uk-width-medium-5-6{
        width:83.333%
    }
    .managerequests-uk-width-medium-1-10{
        width:10%
    }
    .managerequests-uk-width-medium-3-10{
        width:30%
    }
    .managerequests-uk-width-medium-7-10{
        width:70%
    }
    .managerequests-uk-width-medium-9-10{
        width:90%
    }
}
@media (min-width:960px){
    .managerequests-uk-width-large-1-1{
        width:100%
    }
    .managerequests-uk-width-large-1-2,.managerequests-uk-width-large-2-4,.managerequests-uk-width-large-3-6,.managerequests-uk-width-large-5-10{
        width:50%
    }
    .managerequests-uk-width-large-1-3,.managerequests-uk-width-large-2-6{
        width:33.333%
    }
    .managerequests-uk-width-large-2-3,.managerequests-uk-width-large-4-6{
        width:66.666%
    }
    .managerequests-uk-width-large-1-4{
        width:25%
    }
    .managerequests-uk-width-large-3-4{
        width:75%
    }
    .managerequests-uk-width-large-1-5,.managerequests-uk-width-large-2-10{
        width:20%
    }
    .managerequests-uk-width-large-2-5,.managerequests-uk-width-large-4-10{
        width:40%
    }
    .managerequests-uk-width-large-3-5,.managerequests-uk-width-large-6-10{
        width:60%
    }
    .managerequests-uk-width-large-4-5,.managerequests-uk-width-large-8-10{
        width:80%
    }
    .managerequests-uk-width-large-1-6{
        width:16.666%
    }
    .managerequests-uk-width-large-5-6{
        width:83.333%
    }
    .managerequests-uk-width-large-1-10{
        width:10%
    }
    .managerequests-uk-width-large-3-10{
        width:30%
    }
    .managerequests-uk-width-large-7-10{
        width:70%
    }
    .managerequests-uk-width-large-9-10{
        width:90%
    }
}
@media (min-width:1220px){
    .managerequests-uk-width-xlarge-1-1{
        width:100%
    }
    .managerequests-uk-width-xlarge-1-2,.managerequests-uk-width-xlarge-2-4,.managerequests-uk-width-xlarge-3-6,.managerequests-uk-width-xlarge-5-10{
        width:50%
    }
    .managerequests-uk-width-xlarge-1-3,.managerequests-uk-width-xlarge-2-6{
        width:33.333%
    }
    .managerequests-uk-width-xlarge-2-3,.managerequests-uk-width-xlarge-4-6{
        width:66.666%
    }
    .managerequests-uk-width-xlarge-1-4{
        width:25%
    }
    .managerequests-uk-width-xlarge-3-4{
        width:75%
    }
    .managerequests-uk-width-xlarge-1-5,.managerequests-uk-width-xlarge-2-10{
        width:20%
    }
    .managerequests-uk-width-xlarge-2-5,.managerequests-uk-width-xlarge-4-10{
        width:40%
    }
    .managerequests-uk-width-xlarge-3-5,.managerequests-uk-width-xlarge-6-10{
        width:60%
    }
    .managerequests-uk-width-xlarge-4-5,.managerequests-uk-width-xlarge-8-10{
        width:80%
    }
    .managerequests-uk-width-xlarge-1-6{
        width:16.666%
    }
    .managerequests-uk-width-xlarge-5-6{
        width:83.333%
    }
    .managerequests-uk-width-xlarge-1-10{
        width:10%
    }
    .managerequests-uk-width-xlarge-3-10{
        width:30%
    }
    .managerequests-uk-width-xlarge-7-10{
        width:70%
    }
    .managerequests-uk-width-xlarge-9-10{
        width:90%
    }
}
@media (min-width:768px){
    [class*=managerequests-uk-push-],[class*=managerequests-uk-pull-]{
        position:relative
    }
    .managerequests-uk-push-1-2,.managerequests-uk-push-2-4,.managerequests-uk-push-3-6,.managerequests-uk-push-5-10{
        left:50%
    }
    .managerequests-uk-push-1-3,.managerequests-uk-push-2-6{
        left:33.333%
    }
    .managerequests-uk-push-2-3,.managerequests-uk-push-4-6{
        left:66.666%
    }
    .managerequests-uk-push-1-4{
        left:25%
    }
    .managerequests-uk-push-3-4{
        left:75%
    }
    .managerequests-uk-push-1-5,.managerequests-uk-push-2-10{
        left:20%
    }
    .managerequests-uk-push-2-5,.managerequests-uk-push-4-10{
        left:40%
    }
    .managerequests-uk-push-3-5,.managerequests-uk-push-6-10{
        left:60%
    }
    .managerequests-uk-push-4-5,.managerequests-uk-push-8-10{
        left:80%
    }
    .managerequests-uk-push-1-6{
        left:16.666%
    }
    .managerequests-uk-push-5-6{
        left:83.333%
    }
    .managerequests-uk-push-1-10{
        left:10%
    }
    .managerequests-uk-push-3-10{
        left:30%
    }
    .managerequests-uk-push-7-10{
        left:70%
    }
    .managerequests-uk-push-9-10{
        left:90%
    }
    .managerequests-uk-pull-1-2,.managerequests-uk-pull-2-4,.managerequests-uk-pull-3-6,.managerequests-uk-pull-5-10{
        left:-50%
    }
    .managerequests-uk-pull-1-3,.managerequests-uk-pull-2-6{
        left:-33.333%
    }
    .managerequests-uk-pull-2-3,.managerequests-uk-pull-4-6{
        left:-66.666%
    }
    .managerequests-uk-pull-1-4{
        left:-25%
    }
    .managerequests-uk-pull-3-4{
        left:-75%
    }
    .managerequests-uk-pull-1-5,.managerequests-uk-pull-2-10{
        left:-20%
    }
    .managerequests-uk-pull-2-5,.managerequests-uk-pull-4-10{
        left:-40%
    }
    .managerequests-uk-pull-3-5,.managerequests-uk-pull-6-10{
        left:-60%
    }
    .managerequests-uk-pull-4-5,.managerequests-uk-pull-8-10{
        left:-80%
    }
    .managerequests-uk-pull-1-6{
        left:-16.666%
    }
    .managerequests-uk-pull-5-6{
        left:-83.333%
    }
    .managerequests-uk-pull-1-10{
        left:-10%
    }
    .managerequests-uk-pull-3-10{
        left:-30%
    }
    .managerequests-uk-pull-7-10{
        left:-70%
    }
    .managerequests-uk-pull-9-10{
        left:-90%
    }
}
.managerequests-uk-panel{
    display:block;
    position:relative
}
.managerequests-uk-panel,.managerequests-uk-panel:hover{
    text-decoration:none
}
.managerequests-uk-panel:after,.managerequests-uk-panel:before{
    content:"";
    display:table
}
.managerequests-uk-panel:after{
    clear:both
}
.managerequests-uk-panel>:not(.managerequests-uk-panel-title):last-child{
    margin-bottom:0
}
.managerequests-uk-panel-title{
    margin-top:0;
    margin-bottom:15px;
    font-size:18px;
    line-height:24px;
    font-weight:400;
    text-transform:none;
    color:#444
}
.managerequests-uk-panel-badge{
    position:absolute;
    top:0;
    right:0;
    z-index:1
}
.managerequests-uk-panel-teaser{
    margin-bottom:15px
}
.managerequests-uk-panel-body{
    padding:15px
}
.managerequests-uk-panel-box{
    padding:15px;
    background:#fafafa;
    color:#444;
    border:1px solid #ddd;
    border-radius:4px
}
.managerequests-uk-panel-box-hover:hover{
    color:#444
}
.managerequests-uk-panel-box .managerequests-uk-panel-title{
    color:#444
}
.managerequests-uk-panel-box .managerequests-uk-panel-badge{
    top:10px;
    right:10px
}
.managerequests-uk-panel-box>.managerequests-uk-panel-teaser{
    margin-top:-16px;
    margin-left:-16px;
    margin-right:-16px
}
.managerequests-uk-panel-box>.managerequests-uk-nav-side{
    margin:0 -15px
}
.managerequests-uk-panel-box-primary{
    background-color:#ebf7fd;
    color:#2d7091;
    border-color:rgba(45,112,145,.3)
}
.managerequests-uk-panel-box-primary-hover:hover{
    color:#2d7091
}
.managerequests-uk-panel-box-primary .managerequests-uk-panel-title{
    color:#2d7091
}
.managerequests-uk-panel-box-secondary{
    background-color:#fff;
    color:#444
}
.managerequests-uk-panel-box-secondary-hover:hover{
    color:#444
}
.managerequests-uk-panel-box-secondary .managerequests-uk-panel-title{
    color:#444
}
.managerequests-uk-panel-hover{
    padding:15px;
    color:#444;
    border:1px solid transparent;
    border-radius:4px
}
.managerequests-uk-panel-hover:hover{
    background:#fafafa;
    color:#444;
    border-color:#ddd
}
.managerequests-uk-panel-hover .managerequests-uk-panel-badge{
    top:10px;
    right:10px
}
.managerequests-uk-panel-hover>.managerequests-uk-panel-teaser{
    margin-top:-16px;
    margin-left:-16px;
    margin-right:-16px
}
.managerequests-uk-panel-header .managerequests-uk-panel-title{
    padding-bottom:10px;
    border-bottom:1px solid #ddd;
    color:#444
}
.managerequests-uk-panel-space{
    padding:30px
}
.managerequests-uk-panel-space .managerequests-uk-panel-badge{
    top:30px;
    right:30px
}
.managerequests-uk-panel+.managerequests-uk-panel-divider{
    margin-top:50px!important
}
.managerequests-uk-panel+.managerequests-uk-panel-divider:before{
    content:"";
    display:block;
    position:absolute;
    top:-25px;
    left:0;
    right:0;
    border-top:1px solid #ddd
}
@media (min-width:1220px){
    .managerequests-uk-panel+.managerequests-uk-panel-divider{
        margin-top:70px!important
    }
    .managerequests-uk-panel+.managerequests-uk-panel-divider:before{
        top:-35px
    }
}
.managerequests-uk-panel-box .managerequests-uk-panel-teaser{
    border-top-left-radius:4px;
    border-top-right-radius:4px;
    overflow:hidden;
    -webkit-transform:translateZ(0)
}
.managerequests-uk-block{
    position:relative;
    box-sizing:border-box;
    padding-top:20px;
    padding-bottom:20px
}
@media (min-width:768px){
    .managerequests-uk-block{
        padding-top:50px;
        padding-bottom:50px
    }
}
.managerequests-uk-block:after,.managerequests-uk-block:before{
    content:"";
    display:table
}
.managerequests-uk-block:after{
    clear:both
}
.managerequests-uk-block>:last-child{
    margin-bottom:0
}
.managerequests-uk-block-large{
    padding-top:20px;
    padding-bottom:20px
}
@media (min-width:768px){
    .managerequests-uk-block-large{
        padding-top:50px;
        padding-bottom:50px
    }
}
@media (min-width:960px){
    .managerequests-uk-block-large{
        padding-top:100px;
        padding-bottom:100px
    }
}
.managerequests-uk-block-default{
    background:#fff
}
.managerequests-uk-block-muted{
    background:#f9f9f9
}
.managerequests-uk-block-primary{
    background:#00a8e6
}
.managerequests-uk-block-secondary{
    background:#222
}
.managerequests-uk-block-default+.managerequests-uk-block-default,.managerequests-uk-block-muted+.managerequests-uk-block-muted,.managerequests-uk-block-primary+.managerequests-uk-block-primary,.managerequests-uk-block-secondary+.managerequests-uk-block-secondary{
    padding-top:0
}
.md-card.request-card{
    position:relative;
    border-radius: 6px;
    -webkit-backdrop-filter: blur(30px);
    backdrop-filter: blur(30px);
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
    border: solid 1px #cdd2da;
    background-color: #d6e2ef;
    cursor: pointer;
}
.md-card.request-card+.md-card.request-card,.md-card.request-card+.managerequests-uk-grid,.managerequests-uk-grid+.md-card.request-card{
    margin-top:25px
}
.md-card.request-card .full_width_in_card{
    padding:16px 24px;
    background:rgba(0,0,0,.085)
}
.md-card.request-card .md-card-toolbar{
    height:48px;
    padding:0 16px;
    border-bottom:1px solid rgba(0,0,0,.12);
    background:#fff
}
.md-card.request-card .md-card-toolbar:after,.md-card.request-card .md-card-toolbar:before{
    content:" ";
    display:table
}
.md-card.request-card .md-card-toolbar:after{
    clear:both
}
.md-card.request-card .md-card-toolbar:after,.md-card.request-card .md-card-toolbar:before{
    content:" ";
    display:table
}
.md-card.request-card .md-card-toolbar:after{
    clear:both
}
.md-card.request-card .md-card-toolbar-heading-text{
    font:500 14px/50px Roboto,sans-serif;
    color:#212121;
    margin:0;
    float:left;
    overflow:hidden;
    height:48px
}
.md-card.request-card .md-card-toolbar-heading-text.large{
    font-size:18px;
    font-weight:400
}
.md-card.request-card .md-card-toolbar .md-toggle-group{
    float:left;
    margin:8px 0 0 16px
}
.md-card.request-card .md-card-toolbar .md-toggle-group.md-toggle-group-small{
    margin-top:10px
}
.md-card.request-card .md-card-toolbar .md-card-toolbar-actions{
    float:right;
    padding-top:10px
}
.md-card.request-card .md-card-toolbar .md-card-toolbar-actions .managerequests-uk-open .md-card-toolbar-icon{
    background:rgba(0,0,0,.085);
    color:#212121
}
.md-card.request-card .md-card-toolbar .md-card-toolbar-actions .md-card-dropdown{
    display:inline-block;
    position:relative
}
.md-card.request-card .md-card-toolbar .md-card-toolbar-actions .selectize-control{
    min-width:220px;
    margin-top:-3px
}
.md-card.request-card .md-card-toolbar .md-card-toolbar-actions .selectize-control .selectize-input{
    min-height:30px;
    padding:4px 8px
}
.md-card.request-card .md-card-toolbar .md-card-toolbar-actions .selectize-control .selectize-dropdown{
    margin-top:-34px
}
.md-card.request-card .md-card-toolbar .md-icon+.md-card-dropdown{
    margin-left:4px
}
.md-card.request-card .md-card-toolbar .md-card-fullscreen-deactivate{
    margin:9px 8px 0 0
}
.md-card.request-card .md-card-toolbar-input{
    border:none;
    font:400 18px/24px Roboto,sans-serif;
    height:auto;
    background:0 0!important;
    padding:12px 0;
    width:50%;
    -webkit-box-sizing:border-box;
    box-sizing:border-box
}
.md-card.request-card .md-card-toolbar .managerequests-uk-tab{
    margin-top:-2px;
    border-bottom:none
}
.md-card.request-card .md-card-toolbar .managerequests-uk-tab li>a{
    padding:10px 8px!important
}
.md-card.request-card .md-card-head{
    height:190px;
    position:relative;
    border-bottom:1px solid transparent
}
.md-card.request-card .md-card-head-menu{
    position:absolute;
    right:8px;
    top:8px;
    border: 1px solid #e0e3e6;
    border-radius: 4px;
    background:#fff;
}
.img-div {
    width: 86px;
    height: 86px;
    border-radius: 50%;
    margin-top: 20px;
    display: inline-block;
}
.md-card.request-card .md-card-head-avatar{
    width:75px;
    height:75px;
    border-radius:50%;
    margin-top:4px;
    display:inline-block
}
.md-card.request-card .md-card-head-text{
    padding:8px 10px 8px;
    font-size: 15px;
    color:#303031;
    margin:0;
    font-weight: bold;
    line-height: 1.19;
}
.md-card.request-card .md-card-head-text span:not(.listNavSelector){
    display:block;
    font-size: 15px;
    margin-top: 5px;
    margin-bottom: 0px;
    color: #303031;
    font-weight: bold;
    line-height: 1.19;
}
.md-card.request-card .md-card-head-text.text_dark{
    color: #303031 !important
}
.md-card.request-card .md-card-head-text-over{
    background-image:-webkit-gradient(linear,left top,left bottom,from(rgba(0,0,0,.65)),to(rgba(0,0,0,0)));
    background-image:linear-gradient(to bottom,rgba(0,0,0,.65) 0,rgba(0,0,0,0) 100%)
}
.md-card.request-card .md-card-head-subtext{
    position:absolute;
    bottom:10px;
    left:0;
    right:0;
    padding:0 16px;
    text-align:right;
    color:#fff
}
.md-card.request-card .md-card-head-subtext span{
    font-size:26px
}
.md-card.request-card .md-card-head-icon{
    font-size:48px;
    color:#fff;
    vertical-align:middle
}
.md-card.request-card .md-card-head.head_background{
    background-repeat:no-repeat;
    background-position:center center;
    background-size:cover;
    border-bottom-color:transparent
}
.md-card.request-card .md-card-head.head_background .md-card-head-text{
    color:#fff
}
.md-card.request-card .md-card-head.head_background_top{
    background-repeat:no-repeat;
    background-position:center top
}
.md-card.request-card .md-card-head.head_background_bottom{
    background-repeat:no-repeat;
    background-position:center bottom
}
.md-card.request-card .md-card-head .head_chart{
    height:100px;
    width:100%;
    position:absolute!important;
    left:0;
    top:40px
}
.md-card.request-card .md-card-head .fitVid_player{
    width:100%;
    height:160px;
    overflow:hidden
}
.md-card.request-card .md-card-head-img{
    height:100%;
    width: auto;
}
.md-card.request-card .md-card-head iframe{
    height:160px
}
.md-card.request-card .md-card-content{
    padding: 5px 12px 5px;
}
.md-card.request-card .md-card-content.padding-reset{
    padding:0
}
.md-card.request-card .md-card-content.large-padding{
    padding:24px 35px
}
.md-card.request-card .md-card-content.small-padding{
    padding:8px
}
.md-card.md-card-fullscreen-activate{
    cursor:pointer
}
.md-card.md-card-fullscreen{
    position:fixed;
    z-index:9998;
    overflow-x:hidden;
    cursor:default
}
.md-card.md-card-fullscreen .md-card-fullscreen-activate{
    display:none
}
.md-card.md-card-fullscreen .md-card-fullscreen-hide{
    display:none
}
.md-card.request-card .md-card-fullscreen-content{
    display:none;
    padding:16px
}
.md-card-fullscreen-content-hidden .md-card.request-card .md-card-fullscreen-content{
    display:block;
    visibility:hidden;
    padding:0
}
.md-card.mdToolbar_fixed{
    overflow-y:hidden
}
.md-card.mdToolbar_fixed>.md-card-toolbar{
    position:fixed;
    left:0;
    right:0;
    top:0;
    z-index:9999;
    -webkit-box-shadow:0 3px 6px rgba(0,0,0,.16),0 3px 6px rgba(0,0,0,.23);
    box-shadow:0 3px 6px rgba(0,0,0,.16),0 3px 6px rgba(0,0,0,.23)
}
.md-card.mdToolbar_fixed>.md-card-content{
    overflow-y:scroll;
    -webkit-box-sizing:border-box;
    box-sizing:border-box;
    position:absolute;
    width:100%;
    top:48px;
    bottom:0
}
.md-card.mdToolbar_fixed>.md-card-content .md-card-fullscreen-content{
    padding:16px 0
}
.md-card.request-card.md-card-overlay{
    overflow:hidden;
    padding-bottom:54px
}
.md-card.request-card .md-card-overlay .md-card-content{
    height:142px;
    overflow:hidden;
    -webkit-box-sizing:border-box;
    box-sizing:border-box
}
.md-card.request-card .md-card-overlay .md-card-content.no_truncate{
    position:relative
}
.md-card.request-card.md-card-overlay .md-card-content.no_truncate:after{
    position:absolute;
    bottom:0;
    left:0;
    right:0;
    height:8px;
    background-image:-webkit-gradient(linear,left bottom,left top,color-stop(50%,#fff),to(rgba(255,255,255,0)));
    background-image:linear-gradient(to top,#fff 50%,rgba(255,255,255,0) 100%);
    display:block;
    content:'';
    z-index:10
}
.md-card.request-card.md-card-overlay .md-card-content>pre{
    margin-top:0;
    max-height:110px
}
.md-card.request-card.md-card-overlay .md-card-content>pre>code{
    overflow:hidden
}
.md-card.request-card.md-card-overlay .md-card-overlay-content{
    position:absolute;
    top:100%;
    left:0;
    right:0;
    padding:0 16px;
    margin-top:-54px;
    border-top:1px solid rgba(0,0,0,.12);
    text-align:left;
    bottom:0;
    background:#fff;
    z-index:10;
    -webkit-transition:all 280ms cubic-bezier(.4,0,.2,1);
    transition:all 280ms cubic-bezier(.4,0,.2,1)
}
.md-card.request-card.md-card-overlay .md-card-overlay-content p{
    margin:0
}
.md-card.request-card.md-card-overlay .md-card-overlay-content p+*{
    margin-top:16px
}
.md-card.request-card.md-card-overlay .md-card-overlay-content p+p{
    margin-top:4px
}
.md-card.request-card.md-card-overlay .md-card-overlay-header{
    padding:12px 0
}
.md-card.request-card.md-card-overlay .md-card-overlay-header:after,.md-card.request-card.md-card-overlay .md-card-overlay-header:before{
    content:" ";
    display:table
}
.md-card.request-card.md-card-overlay .md-card-overlay-header:after{
    clear:both
}
.md-card.request-card.md-card-overlay .md-card-overlay-header:after,.md-card.request-card.md-card-overlay .md-card-overlay-header:before{
    content:" ";
    display:table
}
.md-card.request-card.md-card-overlay .md-card-overlay-header:after{
    clear:both
}
.md-card.request-card.md-card-overlay .md-card-overlay-header h3,.md-card.request-card.md-card-overlay .md-card-overlay-header h4{
    margin:0;
    text-overflow:ellipsis;
    display:inline-block;
    vertical-align:top;
    white-space:nowrap;
    overflow:hidden;
    width:100%;
    padding-right:32px;
    -webkit-box-sizing:border-box;
    box-sizing:border-box
}
.md-card.request-card.md-card-overlay .md-card-overlay-header .md-icon{
    position:absolute;
    right:12px;
    top:11px
}
.md-card.request-card.md-card-overlay-active .md-card-overlay-content{
    top:-1px;
    margin-top:0
}
/* .md-card.md-card-hover{
    -webkit-transition:all 280ms cubic-bezier(.4,0,.2,1);
    transition:all 280ms cubic-bezier(.4,0,.2,1);
    will-change:box-shadow
}
.md-card.md-card-hover:hover{
    -webkit-box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23);
    box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23)
} */
.managerequests-uk-sortable-dragged .md-card{
    -webkit-box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23);
    box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23)
}
.managerequests-uk-sortable-dragged .md-card.request-card canvas{
    margin:0 auto;
    display:block
}
.md-card.request-card .heading_list{
    padding:0
}
.md-card-danger,.md-card-primary,.md-card-success,.md-card-warning{
    border-left:4px solid transparent
}
.md-card-primary{
    border-left-color:#00448b
}
.md-card-success{
    border-left-color:#7cb342
}
.md-card-danger{
    border-left-color:#e53935
}
.md-card-warning{
    border-left-color:#ffa000
}
.md-card-horizontal{
    position:relative;
    min-height:200px
}
.md-card-horizontal:after,.md-card-horizontal:before{
    content:" ";
    display:table
}
.md-card-horizontal:after{
    clear:both
}
.md-card-horizontal:after,.md-card-horizontal:before{
    content:" ";
    display:table
}
.md-card-horizontal:after{
    clear:both
}
.md-card-horizontal-grid{
    min-height:auto
}
.md-card-horizontal .md-card-head{
    border-right:1px solid rgba(0,0,0,.12);
    border-bottom:none;
    width:200px;
    height:100%;
    position:absolute;
    left:0;
    top:0;
    bottom:0
}
@media only screen and (max-width:767px){
    .md-card-horizontal .md-card-head{
        width:140px
    }
}
.md-card-horizontal .md-card-head-grid{
    border-right:1px solid rgba(0,0,0,.12)
}
.md-card-horizontal .md-card-head-menu{
    right:auto;
    left:8px
}
.md-card-horizontal .md-card-content{
    margin-left:200px
}
@media only screen and (max-width:767px){
    .md-card-horizontal .md-card-content{
        margin-left:140px
    }
}
.md-card-horizontal .md-card-content-grid{
    padding:16px
}
.md-expand,.md-expand-group>*{
    opacity:0
}
.md-card-placeholder{
    min-width:100%
}
.md-card-list-wrapper,.md-card-list-wrapper *,.md-card-list-wrapper :after,.md-card-list-wrapper :before,.md-card-list-wrapper:after,.md-card-list-wrapper:before{
    -webkit-box-sizing:border-box;
    box-sizing:border-box
}
.md-card-list-wrapper .md-card-list-header{
    position:absolute;
    top:-24px;
    left:0
}
.md-card-list-wrapper .md-card-list{
    margin:48px 0 0 0;
    position:relative
}
.md-card-list-wrapper .md-card-list:first-child{
    margin-top:24px
}
.md-card-list-wrapper .md-card-list>ul{
    margin:0;
    padding:0;
    list-style:none
}
.md-card-list-wrapper .md-card-list>ul>li{
    padding:0;
    margin:0;
    list-style:none
}
.md-card-list-wrapper .md-card-list>ul>li{
    min-height:34px;
    padding:8px 16px;
    font-size:13px;
    -webkit-transition:background 150ms,padding .2s;
    transition:background 150ms,padding .2s;
    background:#fff;
    -webkit-box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);
    box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24)
}
.md-card-list-wrapper .md-card-list>ul>li:after,.md-card-list-wrapper .md-card-list>ul>li:before{
    content:" ";
    display:table
}
.md-card-list-wrapper .md-card-list>ul>li:after{
    clear:both
}
.md-card-list-wrapper .md-card-list>ul>li:after,.md-card-list-wrapper .md-card-list>ul>li:before{
    content:" ";
    display:table
}
.md-card-list-wrapper .md-card-list>ul>li:after{
    clear:both
}
.md-card-list-wrapper .md-card-list>ul>li.item-shown{
    background:#fff;
    padding:8px 36px
}
@media only screen and (max-width:767px){
    .md-card-list-wrapper .md-card-list>ul>li.item-shown .md-card-list-item-subject{
        clear:both;
        float:none;
        padding-top:16px
    }
    .md-card-list-wrapper .md-card-list>ul>li.item-shown .md-card-list-item-subject>span{
        white-space:normal
    }
}
.md-card-list-wrapper .md-card-list>ul>li.item-shown .md-card-list-item-sender{
    width:auto;
    overflow:hidden
}
.md-card-list-wrapper .md-card-list>ul>li.item-shown.md-card-list-item-selected{
    position:relative
}
.md-card-list-wrapper .md-card-list>ul>li.item-shown.md-card-list-item-selected:before{
    content:'';
    position:absolute;
    display:block;
    left:0;
    top:0;
    bottom:0;
    width:8px;
    background:#e3f2fd
}
.md-card-list-wrapper .md-card-list .md-card-list-item-avatar-wrapper,.md-card-list-wrapper .md-card-list .md-card-list-item-select,.md-card-list-wrapper .md-card-list .md-card-list-item-sender{
    float:left
}
.md-card-list-wrapper .md-card-list .md-card-list-item-select{
    padding:6px 8px 0 0
}
.md-card-list-wrapper .md-card-list .md-card-list-item-avatar-wrapper,.md-card-list-wrapper .md-card-list .md-card-list-item-date,.md-card-list-wrapper .md-card-list .md-card-list-item-sender,.md-card-list-wrapper .md-card-list .md-card-list-item-subject{
    padding:0 8px
}
.md-card-list-wrapper .md-card-list .md-card-list-item-avatar-wrapper .md-card-list-item-avatar{
    background:#757575;
    color:#fff;
    width:34px;
    border-radius:50%;
    display:block
}
.md-card-list-wrapper .md-card-list .md-card-list-item-avatar-wrapper .md-card-list-item-avatar-large{
    width:82px;
    border-radius:50%
}
.md-card-list-wrapper .md-card-list .md-card-list-item-avatar-wrapper span.md-card-list-item-avatar{
    line-height:34px;
    text-transform:uppercase;
    text-align:center
}
.md-card-list-wrapper .md-card-list .md-card-list-item-sender{
    width:220px;
    line-height:34px
}
.md-card-list-wrapper .md-card-list .md-card-list-item-sender>span{
    text-overflow:ellipsis;
    display:inline-block;
    vertical-align:top;
    white-space:nowrap;
    overflow:hidden;
    width:100%
}
@media only screen and (max-width:1219px){
    .md-card-list-wrapper .md-card-list .md-card-list-item-sender{
        display:none
    }
}
.md-card-list-wrapper .md-card-list .md-card-list-item-subject{
    overflow:hidden;
    font-weight:500
}
.md-card-list-wrapper .md-card-list .md-card-list-item-subject>span{
    line-height:34px;
    text-overflow:ellipsis;
    display:inline-block;
    vertical-align:top;
    white-space:nowrap;
    overflow:hidden;
    width:100%
}
.md-card-list-wrapper .md-card-list .md-card-list-item-subject .md-card-list-item-sender-small{
    display:none
}
@media only screen and (max-width:1219px){
    .md-card-list-wrapper .md-card-list .md-card-list-item-subject .md-card-list-item-sender-small{
        display:block
    }
    .md-card-list-wrapper .md-card-list .md-card-list-item-subject .md-card-list-item-sender-small+span{
        line-height:inherit
    }
}
.md-card-list-wrapper .md-card-list .md-card-list-item-subject .md-card-list-item-sender-small>span{
    text-overflow:ellipsis;
    display:inline-block;
    vertical-align:top;
    white-space:nowrap;
    overflow:hidden;
    width:100%;
    font-size:12px;
    color:#999
}
.md-card-list-wrapper .md-card-list .md-card-list-item-date{
    line-height:34px;
    float:right;
    color:#999
}
@media only screen and (max-width:479px){
    .md-card-list-wrapper .md-card-list .md-card-list-item-date{
        display:none
    }
}
.md-card-list-wrapper .md-card-list .md-card-list-item-menu{
    float:right;
    margin:0 0 0 8px;
    position:relative
}
.md-card-list-wrapper .md-card-list .md-card-list-item-menu .managerequests-uk-dropdown .material-icons{
    margin-right:8px
}
.md-card-list-wrapper .md-card-list .md-card-list-item-content-wrapper{
    display:none;
    clear:both;
    opacity:0
}
.md-card-list-wrapper .md-card-list .md-card-list-item-content{
    padding:16px 16px 0 0;
    max-height:360px;
    overflow-x:hidden;
    margin:0 0 40px;
    top:20px;
    position:relative;
    font-size:14px
}
.md-card-list-wrapper .md-card-list .md-card-list-item-content+.md-card-list-item-reply{
    padding-top:10px
}
.md-card-list-wrapper .md-card-list .md-card-list-item-reply{
    padding:16px 0
}
.md-card-list-wrapper .md-card-list .md-card-list-item-selected{
    background:#e3f2fd
}
.md-list{
    margin:0;
    padding:0;
    list-style:none
}
.md-list>li{
    padding:0;
    margin:0;
    list-style:none
}
.md-list,.md-list *,.md-list :after,.md-list :before,.md-list:after,.md-list:before{
    -webkit-box-sizing:border-box;
    box-sizing:border-box
}
.md-list .managerequests-uk-nestable-list>li,.md-list>li{
    min-height:48px;
    padding:8px 4px;
    -webkit-box-sizing:border-box;
    box-sizing:border-box;
    border-bottom:1px solid rgba(0,0,0,.12);
    position:relative
}
.md-list .managerequests-uk-nestable-list>li>.md-list-content,.md-list>li>.md-list-content{
    overflow:hidden
}
.md-list .managerequests-uk-nestable-list>li>.md-list-content>span,.md-list>li>.md-list-content>span{
    display:block
}
.md-list .managerequests-uk-nestable-list>li>.md-list-content .md-list-heading,.md-list>li>.md-list-content .md-list-heading{
    margin:0;
    font-weight:500;
    display:block;
    overflow:hidden;
    padding-bottom:1px
}
.md-list .managerequests-uk-nestable-list>li>.md-list-content .md-list-menu,.md-list>li>.md-list-content .md-list-menu{
    float:right
}
.md-list .managerequests-uk-nestable-list>li>.md-list-content .md-list-menu .md-list-menu-toggle,.md-list>li>.md-list-content .md-list-menu .md-list-menu-toggle{
    display:block;
    font-size:18px;
    color:rgba(0,0,0,.8);
    width:28px;
    height:28px;
    line-height:28px;
    border-radius:14px;
    text-align:center
}
.md-list .managerequests-uk-nestable-list>li>.md-list-content .managerequests-uk-badge,.md-list>li>.md-list-content .managerequests-uk-badge{
    float:right;
    color:#fff!important
}
.md-list .managerequests-uk-nestable-list>li>.md-list-content .md-list-action,.md-list>li>.md-list-content .md-list-action{
    float:right;
    margin-left:8px;
    margin-top:2px;
    display:none
}
.md-list .managerequests-uk-nestable-list>li>.md-list-content .md-list-action-placeholder,.md-list>li>.md-list-content .md-list-action-placeholder{
    float:right;
    margin-left:8px;
    display:none;
    width:32px;
    height:32px
}
.md-list .managerequests-uk-nestable-list>li .md-list-action-dropdown,.md-list>li .md-list-action-dropdown{
    position:absolute;
    right:16px;
    top:10px;
    display:none
}
.md-list .managerequests-uk-nestable-list>li>a.md-list-content,.md-list>li>a.md-list-content{
    display:block;
    color:#212121
}
.md-list .managerequests-uk-nestable-list>li:last-child,.md-list>li:last-child{
    border-bottom:none
}
.md-list .managerequests-uk-nestable-list>li.md-list-item-active,.md-list>li.md-list-item-active{
    color:#7cb342;
    background:#ededed
}
.md-list .managerequests-uk-nestable-list>li.md-list-item-disabled>.md-list-content,.md-list>li.md-list-item-disabled>.md-list-content{
    color:#bdbdbd
}
.md-list .managerequests-uk-nestable-list>li.md-list-item-disabled>.md-list-content span,.md-list>li.md-list-item-disabled>.md-list-content span{
    color:#bdbdbd!important
}
.md-list .managerequests-uk-nestable-list>li.heading_list,.md-list>li.heading_list{
    min-height:32px;
    padding:32px 8px 16px;
    border-bottom:none;
    background:0 0!important;
    text-transform:uppercase
}
.md-list .managerequests-uk-nestable-list>li:hover>.md-list-addon-element .managerequests-uk-nestable-handle,.md-list>li:hover>.md-list-addon-element .managerequests-uk-nestable-handle,.managerequests-uk-touch .md-list .managerequests-uk-nestable-list>li>.md-list-addon-element .managerequests-uk-nestable-handle,.managerequests-uk-touch .md-list>li>.md-list-addon-element .managerequests-uk-nestable-handle{
    display:block
}
.md-list .managerequests-uk-nestable-list>li:hover>.md-list-content .md-list-action,.md-list .managerequests-uk-nestable-list>li:hover>.md-list-content .md-list-action-placeholder,.md-list>li:hover>.md-list-content .md-list-action,.md-list>li:hover>.md-list-content .md-list-action-placeholder,.managerequests-uk-touch .md-list .managerequests-uk-nestable-list>li>.md-list-content .md-list-action,.managerequests-uk-touch .md-list .managerequests-uk-nestable-list>li>.md-list-content .md-list-action-placeholder,.managerequests-uk-touch .md-list>li>.md-list-content .md-list-action,.managerequests-uk-touch .md-list>li>.md-list-content .md-list-action-placeholder{
    display:block
}
.md-list .managerequests-uk-nestable-list>li:hover .md-list-action-dropdown,.md-list>li:hover .md-list-action-dropdown,.managerequests-uk-touch .md-list .managerequests-uk-nestable-list>li .md-list-action-dropdown,.managerequests-uk-touch .md-list>li .md-list-action-dropdown{
    display:block
}
.md-list .managerequests-uk-nestable-list>li{
    margin-left:64px
}
.md-list-addon>li{
    margin-left:64px;
    position:relative
}
.md-list-addon>li:last-child .md-list-addon-element{
    border-bottom:none;
    bottom:0
}
.md-list-addon>li:first-child .md-list-addon-element{
    top:0
}
.md-list-addon>li.md-list-item-active .md-list-addon-element,.md-list-addon>li.md-list-item-active .md-list-addon-element .material-icons{
    color:#7cb342
}
.md-list-addon-element{
    position:absolute;
    left:-64px;
    top:-1px;
    bottom:-1px;
    width:64px;
    text-align:center;
    padding:8px 0;
    display:block
}
.md-list-addon-element .element-status{
    position:absolute;
    right:12px;
    top:10px;
    width:12px;
    height:12px;
    border-radius:50%;
    background:#bdbdbd;
    border:1px solid #fff
}
.md-list-addon-element .element-status-danger{
    background:#e53935
}
.md-list-addon-element .element-status-success{
    background:#7cb342
}
.md-list-addon-element .element-status-warning{
    background:#ffa000
}
.md-list-addon-element>.md-list-addon-avatar{
    margin-top:2px
}
.md-list-addon-element>.md-list-addon-icon{
    font-size:28px;
    margin-top:4px;
    color:#727272
}
.md-list-addon-element>.material-icons{
    margin-top:6px
}
.md-list-addon-element .icheckbox_md,.md-list-addon-element .iradio_md{
    margin-top:10px
}
.md-list-addon-element .managerequests-uk-nestable-handle{
    position:absolute;
    left:-2px;
    top:12px;
    display:none
}
.md-list-interactive li{
    cursor:pointer
}
.md-list-bg{
    background:#fff
}
.md-list-separated li{
    background:#fff;
    padding:8px
}
.md-list-separated li+li{
    border-top:none;
    margin-top:8px
}
.md-list-bg-no-sep{
    background:#fff;
    padding:8px
}
.md-list-bg-no-sep li>.md-list-content{
    padding:0 4px
}
.md-list-outside>li{
    padding:0
}
.md-list-outside>li>.md-list-content{
    padding:8px 16px;
    display:block;
    color:#212121
}
.md-list-outside>li.md-list-item-active,.md-list-outside>li:hover:not(.heading_list){
    background:rgba(0,0,0,.085)
}
.md-list-outside>li.heading_list{
    padding:32px 16px 16px
}
.md-list-outside.md-list-addon li{
    margin-left:0
}
.md-list-outside.md-list-addon li .md-list-addon-element{
    position:relative;
    top:auto;
    left:auto;
    float:left
}
.md-list-outside.md-list-addon li .md-list-content{
    padding-left:0
}
.md-list-outside-wrapper{
    position:relative
}
.md-list-outside-wrapper .md-list-outside-search{
    position:absolute;
    top:-46px;
    left:16px;
    right:16px;
    z-index:1000
}
.md-list-outside-wrapper .md-list-outside-search .md-input-wrapper{
    padding:0
}
.md-list-outside-wrapper .md-list-outside-search .md-input-wrapper .md-input-bar:after,.md-list-outside-wrapper .md-list-outside-search .md-input-wrapper .md-input-bar:before{
    background:#fff
}
.md-list-outside-wrapper .md-list-outside-search .md-input{
    border-bottom-color:transparent!important
}
.md-list .managerequests-uk-nestable-list{
    padding-left:0
}
.md-list .managerequests-uk-nestable-list .managerequests-uk-nestable-item{
    padding-right:0
}
.md-list .managerequests-uk-nestable-item+.managerequests-uk-nestable-item{
    margin-top:0
}
.md-list-right.md-list-addon>li{
    margin-left:0;
    margin-right:64px
}
.md-list-right.md-list-addon>li .md-list-addon-element{
    left:auto;
    right:-64px
}
.managerequests-uk-touch .md-list-addon-element .managerequests-uk-nestable-handle{
    display:block!important
}
.managerequests-uk-touch .md-list-content .md-list-action,.managerequests-uk-touch .md-list-content .md-list-action-placeholder{
    display:block!important
}
.managerequests-uk-touch .md-list-action-dropdown{
    display:block!important
}

.card-box {
    box-sizing: border-box;
    padding-left: 15px;
    padding-bottom: 20px;
    display: inline-block;
}
.des-box-manage {
    border-radius: 5px;
    padding: 5px 5px;
    color: #00448b !important;
    font-size: 13px;
    font-weight: 500;
}
.pink-box {
    box-shadow: 0 2px 10px 0 rgba(255, 38, 138, 0.55);
    background-color: #ff268a;
}
.blue-box {
    box-shadow: 0 2px 10px 0 rgba(13, 132, 242, 0.36);
    background-color: #00448b;
}
.lightblue-box {
    box-shadow: 0 2px 10px 0 rgba(13, 132, 242, 0.36);
    background-color: #50bcff;
}
.orange-box {
    box-shadow: 0 2px 10px 0 rgba(245, 166, 35, 0.35);
    background-color: #f5a623;
}
.border-orange1 {
    border-color: #ff7f00 !important;
}
.border-green1 {
    border-color: #1a9347 !important;
}
.border-red1 {
    border-color: #e82828 !important;
}

/* Employes List CSS */
/* .md-white-bg, .white-bg {
    background-color: #fff!important;
    color: #303031!important;
}

.content-table {
    position: relative;
    width: 100%;
}
.mat-table {
    background: #fff;
    display: block;
    box-shadow: none;
}
.mat-table-header, .mat-table-block {
    display: flex;
    box-sizing: border-box;
    flex-direction: row;
}
.mat-header-row, .mat-row {
    border-bottom-color: rgba(0,0,0,0);
    display: flex;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    align-items: center;
    min-height: 60px;
    padding: 0 10px;
    margin: 0 24px;
}
.mat-icon-header, .mat-icon-cell {
    max-width: 64px;
    min-width: 64px;
    flex: 1 1 64px;
    box-sizing: border-box;
}
.mat-cell, .mat-header-cell {
    flex: 1;
}
.mat-header-cell {
    color: #4e5764;
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;
}
.m-r-5 {
    margin-right: 5px!important;
}
.md-light-blue-50-bg {
    color: rgba(0,0,0,.87)!important;
}
.list-item:last-child {
    min-height: 65px;
    border-radius: 9px;
    box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.09);
    background-color: #fff;
}
.list-item:last-child {
    border-bottom: 2px solid rgba(231, 236, 241, 0) !important;
}

.mat-ripple {
    overflow: visible;
}
.mat-cell {
    color: rgba(0,0,0,.87);
}
.form-image {
    width: 36px !important;
    height: 36px !important;
}
.formimg img {
    box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);
    transition: all 0.2s linear;
}
.rounded-circle {
    border-radius: 50%!important;
    box-shadow: 0px 4px 5px -2px rgba(0,0,0,0.2), 0px 7px 10px 1px rgba(0,0,0,0.14), 0px 2px 16px 1px rgba(0,0,0,0.12);
    border: 2px solid #fff;
} */


.mat-table {
    background: #fff;
    box-shadow: none;
    display: block;
    margin: 0px 5px 20px;
}
.mat-header-row, .mat-row{
    flex-direction: row;
    box-sizing: border-box;
    display: flex;
    padding: 0px 14px;
}

.mat-header-cell {
    font-size: 14px;
    font-weight: 600;
    color: #00448b;
    display: flex;
    align-items: center;
    overflow: hidden;
    word-wrap: break-word;
    min-height: inherit;
    text-transform: uppercase;
}
.mat-cell, .mat-footer-cell, .mat-header-cell {
    flex: 1;
    display: flex;
    align-items: center;
    overflow: hidden;
    word-wrap: break-word;
    min-height: inherit;
}
.mat-header-cell.mat-header-first, .mat-cell.mat-cell-first {
    flex: 1 1 200px;
    box-sizing: border-box;
    max-width: 200px;
    min-width: 200px;
}
.mat-header-row {
    min-height: 56px;
}
.mat-table .mat-row {
    position: relative;
    cursor: pointer;
    min-height: 65px;
    border-radius: 9px;
    box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.09);
    background-color: #fff;
    margin-bottom: 10px;
}
.mat-header-row, .mat-row {
    border-width: 0;
    border-bottom-width: 1px;
    border-style: solid;
    align-items: center;
    border-bottom-color: rgba(0,0,0,0);
}
.mat-cell .mat-icon {
    background-repeat: no-repeat;
    display: inline-block;
    fill: currentColor;
    height: 24px;
    width: 24px;
    font-weight: 400!important;
    line-height: 1;
}
.mat-cell, .mat-footer-cell {
    font-size: 14px;
    color: #303031;
}
.avatar.avatar-border {
    border: 1.5px solid rgb(205, 210, 218);
    background-color: rgba(255, 255, 255, 0);
    width: 47px !important;
    height: 47px !important;
    border-radius: 50%;
    margin-top: 20px;
    display: inline-block;
    min-width: 47px !important;
}
.avatar.avatar-border img {
    width: 37px !important;
    height: 37px !important;
    border-radius: 50%;
    min-width: 37px !important;
    max-width: 37px !important;
    max-height: 37px !important;
}
.mat-cell .list-group .list-group-item h3 {
    font-size: 14px !important;
    font-weight: 600;
}
.mat-cell .list-group .list-group-item p {
    font-size: 12px !important;
    font-weight: 600 !important;
    color: #4e5764 !important;
}
.mat-cell .list-group .list-group-item>.avatar {
    margin: 0 1rem 0 0 !important;
}
.des-list-box {
    border-radius: 5px;
    padding: 7px 10px;
    color: #fff;
    width: 110px;
    text-align: center;
}
.mat-row:hover .eyeIcon {
    color: #00448b !important;
}

.mat-row:hover .editIcon {
    color: #00448b !important;
}

.mat-row:hover .deleteIcon {
    color: #00448b !important;
}
.mat-row:hover .cloudIcon {
    color: #e82828 !important;
}
.card-group {
    margin-bottom: 2.143rem;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    flex-direction: column;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
}
.card-block {
    position: relative;
    padding: 1.429rem;
    -webkit-box-flex: 1;
    -webkit-flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
}
.card.card-block {
    box-shadow: none;
}
@media (min-width: 480px) {

    .card-group {
        -webkit-flex-flow: row wrap;
        -ms-flex-flow: row wrap;
        flex-flow: row wrap;
    }
    .card-group .card:first-child {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
    .card-group .card {
        margin-bottom: 0;
        -webkit-box-flex: 1;
        -webkit-flex: 1 0 0%;
        -ms-flex: 1 0 0%;
        flex: 1 0 0%;
    }
}
.counter {
    text-align: center;
}
.vertical-align:before {
    display: inline-block;
    height: 100%;
    vertical-align: middle;
    content: "";
}
.vertical-align-bottom, .vertical-align-middle {
    display: inline-block;
    max-width: 100%;
    font-size: 1rem;
}
.vertical-align-middle {
    vertical-align: middle;
}
.counter-lg .counter-icon {
    font-size: 40px;
}
.counter-inverse .counter-icon {
    color: #00448b;
}
.counter-inverse {
    color: #303031;
}
.h-150 {
    height: 150px!important;
}
.modal-qr-block {
    width: 100%;
    position: relative;
    display: block;
    padding: 20px 10px 0px;
    text-align: center;
}
.modal-passport-block {
    width: 100%;
    position: relative;
    display: block;
    padding: 5px 10px 0px;
}
.option__image {
	max-height: 80px;
	margin-right: 10px
}
.option__desc,
.option__image {
	display: inline-block;
	vertical-align: middle
}
.option__desc {
	padding: rem(10px)
}
.option__title {
	font-size: rem(24px)
}
.option__small {
	margin-top: rem(10px);
	display: block
}
.form__label {
	margin-top: 5px!important
}
.badge__img {
	vertical-align: middle;
	float: right
}
.badge__name {
	vertical-align: middle;
	display: inline-block;
	margin-left: 5px;
	float: left
}
.request-section {
    border: solid 1px #70707017;
    background-color: rgba(13, 132, 242, 0.1);
    text-align: left!important;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 43px;
}
.requestsheader {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    min-height: 40px;
    height: 100%;
    position: relative;
    background: #00448b;
    -webkit-box-shadow: none;
    box-shadow: none;
    border-bottom: 1px solid #fff;
}
.requestsheader>.descriptionheader {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 16px 25px;
    border-bottom: 1px solid transparent;
}
.requestsheader>.descriptionheader .description-text-header-left h5 {
    font-size: 16px;
    font-weight: 600;
    margin: 0;
    color: #fff;
}
.requestsheader>.descriptionheader .description-text-header-right {
    font-size: 13px;
    margin-left: auto;
    padding-left: 12px;
    color: #4e5764;
    font-weight: 500;
}
.requestsheader>.descriptionheader .description-text-header-right  {
    display: block;
    margin-top: 30px;
}
.request-tab-header {
    font-size: 16px;
    font-weight: bold;
    line-height: 1.22;
    letter-spacing: 0.77px;
    color: #fff !important;
    margin-top: 10px;
    margin-bottom: 20px;
    width: 100% !important;
    text-align: left;
    padding-left: 63px;
}
.see-link {
    text-decoration: underline;
    font-size: 13px;
    font-weight: normal;
    line-height: 1.2;
    color: #00448b;
    cursor: pointer;
    float: right;
}
.btn-outline-danger:hover {
    color: #fff !important;
    background-color: #F44336;
    border-color: #F44336;
}
.btn-outline-danger {
    color: #F44336 !important;
    background-color: transparent;
    background-image: none;
    border-color: #F44336;
}
.btn-secondary.btn-outline {
    color: #00448b !important;
    background-color: transparent;
    background-image: none;
    border: 1px solid #00448b;
}
.btn-secondary.btn-outline:hover {
    color: #fff !important;
    background-color: #00448b;
    border-color: #00448b;
}

/* .nav-pills.nav-manage-employees .nav-link.active,
.nav-pills.nav-manage-employees .show>.nav-link {
    color: #fff;
    background-color: #00448b;
} */
.nav-pills.nav-manage-employees .nav-link {
    -webkit-border-radius: 18px;
    border-radius: 18px;
}
.nav-pills.nav-manage-employees .nav-link {
    height: 32px;
    color: #fff;
    text-decoration: none;
    border: 1px solid #fff;
    line-height: 32px;
    margin-right: 10px;
    font-size: 14px;
    font-weight: 600;
}
/* .nav-pills.nav-manage-employees .nav-link:hover,
.nav-pills.nav-manage-employees .nav-link:focus {
    text-decoration: none;
    color: #fff !important;
    background-color: #00448b;
} */
.tab-content.employee-tab-content {
    padding: 10px 0px 0px;
}
.nav-pills.nav-manage-employees .nav-link.active,
.nav-pills.nav-manage-employees .nav-item.show .nav-link {
    border-color: #00448b;
    background-color: #d6e2ef;
    color: #00448b !important;
}
.nav-pills.nav-manage-employees .nav-link:hover {
    border-color: #00448b;
    background-color: #d6e2ef;
    color: #00448b !important;
}
</style>


// WEBPACK FOOTER //
// src/components/EmployeeRequest.vue